import React from 'react';
import Enumerable from 'linq';
import { Link } from 'react-router-dom';
import styles from './styles/Cd.sass';

class Cd extends React.Component {
  componentDidMount() {
    const { getCd } = this.props;

    getCd();
  }

  render() {
    const {
      drama,
      situation,
    } = this.props;

    return (
      <div className={styles.cd}>
        <header>
          <img
            src={require('images/cd-header.jpg')}
            alt='cd-header'
          />
        </header>
        <div className={styles.drama}>
          <header>
            ドラマCDシリーズ
          </header>
          <div className={styles.detail}>
            月刊コミックジーン（発行：株式会社KADOKAWA)にて連載中のコミカライズ版「春告と雪息子」をドラマCD化！<br />
            <br />
            雪女を祀る小さな村に住む主人公の少女・春告は、次の元旦から始まる儀式において雪女の生贄となることを宣告される。<br />
            兄カザハ・医者の息子リツカ、謎の青年ハクマの見守る中、御供所となった幼馴染のセイジに世話をされ残された日々を過ごす。そんな中、村の少女たちが次々と行方不明になり、ついには殺されてしまう。雪女様のお怒りだと怯える村人たち。しかし村を取り仕切る大僧正ショハクによって、村人の期待はますます春告へと向かうのだった。
          </div>
          <ul>
            {
              Enumerable
                .from(drama)
                .select((element, index) => (
                  <li key={index}>
                    <Link to={`/cd/drama/${index}`}>
                      <img
                        src={`/images/${element.imageName}`}
                        alt={index}
                      />
                    </Link>
                    <div className={styles.title}>
                      {element.shortTitle}
                    </div>
                    <div className={styles.date}>
                      {element.date}
                    </div>
                    <div className={styles.cd_number}>
                      {element.cdNumber}
                    </div>
                    <div className={styles.price}>
                      {element.price}
                    </div>
                  </li>
                ))
                .toArray()
            }
          </ul>
        </div>
        <div className={styles.situation}>
          <header>
            シチュエーションCDシリーズ
          </header>
          <div className={styles.detail}>
            全5話のストーリーで展開する和風ホラーシチュエーションCDシリーズ。雪女の伝説の残る村で、掟により生け贄となった貴女。<br />
            雪女の血を引く青年たちと過ごす中、閉ざされた世界の真実に、貴女は辿り着くことが出来るのか。<br />
            本編は全編ダミーヘッドマイクにて収録。出演キャストコメント、本編のその後を描くAnother Endingも収録。
          </div>
          <ul>
            {
              Enumerable
                .from(situation)
                .select((element, index) => (
                  <li key={index}>
                    <Link to={`/cd/situation/${index}`}>
                      <img
                        src={`/images/${element.imageName}`}
                        alt={index}
                      />
                    </Link>
                    <div className={styles.title}>
                      {element.shortTitle}
                    </div>
                    <div className={styles.cv}>
                      {`cv.${element.cv}`}
                    </div>
                    <div className={styles.date}>
                      {element.date}
                    </div>
                    <div className={styles.cd_number}>
                      {element.cdNumber}
                    </div>
                    <div className={styles.price}>
                      {element.price}
                    </div>
                  </li>
                ))
                .toArray()
            }
          </ul>
        </div>
      </div>
    );
  }
}

export default Cd



// WEBPACK FOOTER //
// src/components/cd/index.js